/**
 * @description Generic divider component
 * <Divider color="#000" lineStyle="dashed"/>
 * lineStyle puede ser cualquier tipo valido para la propiedad border-style de css
 * @author Camilo Ramirez
 */

import React from 'react';
import PropTypes from 'prop-types';
import DividerContainer from './styles/DividerStyled';

const Divider = ({ color, lineStyle, width, margin }) => (
  <DividerContainer
    color={color}
    lineStyle={lineStyle}
    width={width}
    margin={margin}
  />
);

Divider.propTypes = {
  color: PropTypes.string.isRequired,
  lineStyle: PropTypes.string.isRequired,
  width: PropTypes.string,
  margin: PropTypes.string,
};

Divider.defaultProps = {
  width: 'auto',
  margin: '20px 0',
};

export default Divider;
